import { render, staticRenderFns } from "./adreslistesi.vue?vue&type=template&id=47d7f726"
import script from "./adreslistesi.vue?vue&type=script&lang=js"
export * from "./adreslistesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports